import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { useNavigate, useParams } from "react-router-dom";
import Navigation from "../components/Navigation";
import SEO from "../components/SEO";

import HeroBgImg    from "../assets/images/pictures_gallery/paysage.webp";
import SportImg     from "../assets/images/pictures_gallery/sport.webp";
import ConcertImg   from "../assets/images/pictures_gallery/show1.webp";
import MariageImg   from "../assets/images/pictures_gallery/mariage2.webp";
import PortraitImg  from "../assets/images/pictures_gallery/PortraitG.webp";
import ShootingImg  from "../assets/images/pictures_gallery/shootin1G.webp";
import ExterieurImg from "../assets/images/pictures_gallery/exterieur.webp";
import PaysageImg   from "../assets/images/pictures_gallery/paysage.webp";

const CATEGORIES = [
  { key: "sport",     label: "Sport",     img: SportImg,     alt: "Photographie sportive — action et émotion" },
  { key: "concert",   label: "Concert",   img: ConcertImg,   alt: "Photographie de concert — scène et lumières" },
  { key: "mariage",   label: "Mariage",   img: MariageImg,   alt: "Photographie de mariage — couple en célébration" },
  { key: "portrait",  label: "Portrait",  img: PortraitImg,  alt: "Portrait photographique en studio ou extérieur" },
  { key: "shooting",  label: "Shooting",  img: ShootingImg,  alt: "Shooting photo mode et lifestyle" },
  { key: "exterieur", label: "Extérieur", img: ExterieurImg, alt: "Photographie en extérieur — paysages urbains" },
  { key: "paysage",   label: "Paysage",   img: PaysageImg,   alt: "Photographie de paysage — nature et lumière" },
];

function Gallery() {
  const navigate = useNavigate();
  const { id } = useParams();
  const prefersReduced = useReducedMotion();

  const handleNav = (category) => {
    navigate(`/gallery/${category}/${id}`);
  };

  return (
    <main className="gallery-page">
      <SEO
        title="Galerie"
        path="/gallery"
        description="Portfolio photo : concerts, mariages, portraits, shootings, sport, paysages. Découvrez l'univers d'Alexandre Jack."
      />
      <Navigation />

      {/* ── HERO ─────────────────────────────────────── */}
      <section className="gallery-hero" aria-label="Galerie — introduction">
        <div className="gallery-hero__bg" aria-hidden="true">
          <img src={HeroBgImg} alt="" loading="eager" decoding="async" />
        </div>
        <div className="gallery-hero__overlay" aria-hidden="true" />
        <div className="gallery-hero__content">
          <p className="gallery-hero__eyebrow">Portfolio&nbsp;·&nbsp;Lyon</p>
          <h1 className="gallery-hero__title">Galerie</h1>
          <p className="gallery-hero__tagline">Explorez</p>
        </div>
      </section>

      {/* ── CATEGORY GRID ─────────────────────────────── */}
      <section className="gallery-categories" aria-label="Catégories du portfolio">
        <div className="gallery-categories__header">
          <motion.h2
            className="gallery-categories__title"
            {...(prefersReduced
              ? {}
              : {
                  initial: { opacity: 0, y: 20 },
                  whileInView: { opacity: 1, y: 0 },
                  viewport: { once: true, margin: "-60px" },
                  transition: { duration: 0.55, ease: [0.25, 0.1, 0.25, 1] },
                })}
          >
            Univers
          </motion.h2>
          <motion.p
            className="gallery-categories__subtitle"
            {...(prefersReduced
              ? {}
              : {
                  initial: { opacity: 0, y: 20 },
                  whileInView: { opacity: 1, y: 0 },
                  viewport: { once: true, margin: "-60px" },
                  transition: { duration: 0.55, ease: [0.25, 0.1, 0.25, 1], delay: 0.06 },
                })}
          >
            Choisissez une catégorie
          </motion.p>
        </div>

        <ul className="gallery-grid">
          {CATEGORIES.map(({ key, label, img, alt }, i) => (
            <motion.li
              key={key}
              {...(prefersReduced
                ? {}
                : {
                    initial: { opacity: 0, y: 20 },
                    whileInView: { opacity: 1, y: 0 },
                    viewport: { once: true, margin: "-60px" },
                    transition: { duration: 0.55, ease: [0.25, 0.1, 0.25, 1], delay: i * 0.06 },
                  })}
            >
              <button
                className="gallery-tile"
                onClick={() => handleNav(key)}
                type="button"
                aria-label={`Voir la galerie ${label}`}
              >
                <img src={img} alt={alt} loading="lazy" decoding="async" />
                <div className="gallery-tile__overlay" aria-hidden="true" />
                <div className="gallery-tile__label">
                  <span>{label}</span>
                  <span className="gallery-tile__arrow" aria-hidden="true">→</span>
                </div>
              </button>
            </motion.li>
          ))}
        </ul>
      </section>
    </main>
  );
}

export default Gallery;
